import { MetricsKind } from "helpers/metrics/types";
import { RowComputeParams } from "./types";
import { sum } from "./sum";
import { safeParseFloat } from "lib/number";

export const AVERAGE_COST = (params: RowComputeParams) => {
    const { mainRowNodes, getterParams, gridViewRef } = params;

    const unitsValues = gridViewRef.current.getMetricValuesForRows(
        getterParams.column.getColId(),
        MetricsKind.UNITS,
        mainRowNodes
    );
    const costValues = gridViewRef.current.getMetricValuesForRows(
        getterParams.column.getColId(),
        MetricsKind.TOTAL_COST,
        mainRowNodes
    );

    const totalUnits = sum(unitsValues);
    const totalCost = sum(costValues);

    return safeParseFloat(totalCost / totalUnits, 0);
};
